export const MAXIMUM_WITHDRAWAL_AMOUNT_DAILY_FOR_BASIC_AUTH = 400000;
